
import { Pipe, PipeTransform } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CarEquipment } from '../../models/carEquipment';

@Pipe({
    name: 'equipmentSource'
})
export class EquipmentSourcePipe implements PipeTransform {
    filterDictionary = new Map<string, string>();

    transform(equipments: MatTableDataSource<CarEquipment>, category: string): MatTableDataSource<CarEquipment> {
        equipments.filterPredicate = function (record, filter) {
            var map = new Map(JSON.parse(filter));
            let isMatch = false;
            for (let [key, value] of map) {
                isMatch = (value == "Tous") || (record[key as keyof CarEquipment] == value);
                if (!isMatch) return false;
            }
            return isMatch;
        }

        this.filterDictionary.set('categoryName', category);
        var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
        equipments.filter = jsonString;

        return equipments;
    }

}
